import { IRouteConfig } from '@/router/types';

export default [
  {
    path: '/photo-center',
    name: 'PhotoCenter',
    component: () => import('@/layouts/main/index.vue'),
    meta: {
      title: '拍照中心'
    },
    children: [
      {
        path: 'task/list',
        name: 'PhotoCenterTaskList',
        component: () => import('./task/views/list/index.vue'),
        meta: {
          title: '任务列表',
          auth: true,
        },
      },
      {
        path: 'task/detail/:id',
        name: 'PhotoCenterTaskDetail',
        component: () => import('./task/views/detail/index.vue'),
        meta: {
          title: '任务详情',
          auth: true,
          activeMenu: 'PhotoCenterTaskList',
        },
      },
    ],
  }
] as IRouteConfig[];
